import React from 'react';
import styled from 'styled-components';
import { BarChart, ChartContainer } from 'components';
import { Loadable } from 'components/types';
import { theme, toRem } from 'design';
import { IPayoutStateByDate } from 'types';
import { paymentStatToChartPoints } from 'utils';

interface IPaidPaymentChartProps extends Loadable {
  paymentStats?: IPayoutStateByDate[];
}

const StyledChartContainer = styled(ChartContainer)`
  padding: ${toRem(theme.space.xl)} 0 ${toRem(theme.space['3xl'])} 0;

  @media (min-width: ${theme.breakpoint.small}px) {
    padding: 0 0 ${toRem(theme.space['3xl'])} 0;
  }
`;

const PaidPaymentsChart = ({ isLoading: statsLoading, paymentStats }: IPaidPaymentChartProps) => {
  const chartData = paymentStats ? paymentStatToChartPoints(paymentStats) : [];

  return (
    <StyledChartContainer>
      <BarChart isLoading={statsLoading} data={chartData} />
    </StyledChartContainer>
  );
};

export default PaidPaymentsChart;
